












































































































import Vue from 'vue'
import { getModule } from 'vuex-module-decorators'
import Component from 'vue-class-component'
import ErrorMessages from '@/components/ErrorMessages.vue'
import { FacilityModule } from '@/store/modules/facility.module'
import { IPointClickCareCredentials } from '@zunta/configurations'
import Card from '@/components/Card.vue'
import InputV2 from '@/components/inputsV2/InputV2.vue'
import InputPassword from '@/components/inputsV2/InputPassword.vue'
import { required } from 'vuelidate/lib/validators'
import InputValidator from '@/components/inputsV2/InputValidator.vue'
import Checkbox from '@/components/inputsV2/Checkbox.vue'
import Api from '@/api'

@Component({
  props: {
    mode: {
      type: String,
      default: 'normal'
    }
  },
  components: {
    InputValidator,
    InputPassword,
    InputV2,
    Card,
    ErrorMessages,
    Checkbox
  }
})
export default class FacilityLogin extends Vue {
  facilityModuleInstance: FacilityModule = getModule(FacilityModule, this.$store)
  error: string = ''
  user: any = Api.getUser()

  username: string = ''
  password: string = ''
  useNewPCCLogin: boolean = false

  isLoggingIn: boolean = false

  get isSuperAdmin () {
    return this.user.isRootAccess()
  }

  validations (): any {
    return {
      username: {
        required
      },
      password: {
        required
      }
    }
  }

  async login () {
    this.$v.$touch()
    if (this.$v.$anyError) {
      return
    }

    this.isLoggingIn = true
    this.error = ''

    const facilityDto: IPointClickCareCredentials = {
      username: this.username,
      password: this.password,
      useNewPCCLogin: this.useNewPCCLogin
    }

    this.$eventBus.$emit('loading:enable', { message: 'Fetching Facilities' })
    const result = await this.facilityModuleInstance.getAllFacilitiesByPointClickCareCredentials(facilityDto)
    this.$eventBus.$emit('loading:disable')

    this.isLoggingIn = false

    if (!result) {
      this.error = 'Wrong credential'
      return
    }

    if (this.$props.mode === 'setup-wizard') {
      this.$emit('next')
    } else {
      this.$router.push({ name: 'management-facilities-import' })
    }
  }

  cancel () {
    this.$router.push({ name: 'management-facilities' })
  }
}
